import { render, staticRenderFns } from "./veHqHaopin.vue?vue&type=template&id=23bf24ba&scoped=true"
import script from "./veHqHaopin.vue?vue&type=script&lang=js"
export * from "./veHqHaopin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bf24ba",
  null
  
)

export default component.exports